import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const DanalResult = () => {
  return <CommonResult />;
};

export default DanalResult;
